import USER_ROLES from '../../constants/user-roles'
import { get } from 'lodash'

const isAdmin = (user = {}) => {
    const rolesCode = get(user, 'rolesCode', '') || ''
    return rolesCode.includes(USER_ROLES.ADMIN)
}

export default isAdmin